/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import Container from 'components/Container';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

const mock = [
  {
    title: 'Navigating Local Labor Laws',
    subtitle: 'Expanding without a local entity',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon1.png"
        alt="icon"
      />
    ),
  },
  {
    title: 'Inefficient Payroll Management',
    subtitle: 'Managing payroll for large teams',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon2.png"
        alt="icon"
      />
    ),
  },
  {
    title: 'Talent Shortage in New Markets',
    subtitle: 'Lack of local talent slows business expansion',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon3.png"
        alt="icon"
      />
    ),
  },
];

const SimpleCentered = (): JSX.Element => {
  const theme = useTheme();
  const t = useTranslations('GlobalExpansion');
  return (
    <Container>
      <Box>
        <Box marginBottom={4}>
          <Box marginBottom={2}>
            <Typography
              variant="h4"
              color="text.primary"
              align={'center'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
            >
              {t('Global expansion challenges')}
            </Typography>
            {/* <Typography
              variant="h6"
              component="p"
              color="text.secondary"
              sx={{ fontWeight: 400 }}
              align={'center'}
            >
              Build a beautiful, modern website with flexible, fully
              customizable, atomic MUI components.
            </Typography> */}
          </Box>
        </Box>
        <Grid container spacing={2}>
          {mock.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box width={1} height={1}>
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  <Box
                    // component={Avatar}
                    // width={60}
                    // height={60}
                    marginBottom={2}
                    // bgcolor={alpha(theme.palette.primary.main, 0.1)}
                    // color={theme.palette.primary.main}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    sx={{ fontWeight: 500 }}
                    align={'center'}
                  >
                    {t(item.title)}
                  </Typography>
                  <Typography align={'center'} color="text.secondary">
                    {t(item.subtitle)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default SimpleCentered;
